import {
	genreList as genres,
	combinedGenres,
	dateTitleText
} from 'Shared/common/Macros';

/*
	NOTE poster macros need to return undefined when no data so
	     the poster builder can show a default.
*/


export type Macro = (...args: unknown[]) => unknown;

function standardDate(times)
{
	if (times?.customLabel)
		return times.customLabel;

	const text = dateTitleText(times?.frequency,times?.startSingle,times?.startTime,times?.allDay,
		times?.weekdays,times?.days,times?.week,times?.weekday);

	return text === '' ? undefined : text;
}


/* Every macro available to poster templates. */
export const macros = {
	genres,
	combinedGenres,
	standardDate
};
